module.exports = __webpack_public_path__ + "static/media/b0_p10_clickable_b.8f63d10a.mp3";